import { atom } from "jotai"

export const productTypeAtom = atom('Crown & Bridge')
export const isCrownBridgeAtom = atom((get) => get(productTypeAtom) === 'Crown & Bridge')
export const isDentureAtom = atom((get) => get(productTypeAtom) === 'Dentures')
export const isApplianceAtom = atom((get) => get(productTypeAtom) === 'Appliances')
export const isDentureOrApplianceAtom = atom((get) => get(isDentureAtom) || get(isApplianceAtom))